import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=7a10b77c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=7a10b77c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10b77c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a10b77c')) {
      api.createRecord('7a10b77c', component.options)
    } else {
      api.reload('7a10b77c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=7a10b77c&scoped=true&", function () {
      api.rerender('7a10b77c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2eKj0yD3V9saX/JS/comp/SearchFilterTokens.vue"
export default component.exports